import IconButton, { IconButtonProps } from '@mui/material/IconButton'
import Button, { ButtonProps } from '@mui/material/Button'
import SvgICon from '@mui/material/SvgIcon'
import {
  Atlas as IconAtlas,
  LaserSwap as IconLaserSwap,
  Telegram as IconTelegram,
} from 'components/Icons/SvgIcon'

import { diceplanet, dragon, coming } from './images'
import ImageLink, { ImageLinkProps } from './ImageLink'

import { config } from 'configs'

const LaserSwapPath = (config<string>('links.laserswap_pair')).replace('{address}', config('token.PMT.address'))
export function LaserSwap({ title, ...props }: ButtonProps) {
  return (
    <Button
      size="large"
      color="inherit"
      startIcon={<SvgICon component={IconLaserSwap} fontSize={props.size ?? 'large'} inheritViewBox />}
      href={LaserSwapPath}
      {...props}
    />
  )
}

const DicePlanetPath = config<string>('links.dice_planet')
export function DicePlanet({ image, href, title, ...props }: Partial<ImageLinkProps>) {
  return (
    <ImageLink
      image={diceplanet}
      href={DicePlanetPath}
      textColor="#ecb633"
      textSize={16}
      textPosition={-8}
      {...props}
    />
  )
}

export function Altas({ size = 'large', ...props}: IconButtonProps) {
  return (
    <IconButton
      size={size}
      {...props}
    >
      <SvgICon component={IconAtlas} fontSize={size} inheritViewBox />
    </IconButton>
  )
}

const PlanetMasterPath = config<string>('links.planet_master')
export function PlanetMaster({ image, href, title, ...props }: Partial<ImageLinkProps>) {
  return (
    <ImageLink
      image={dragon}
      href={PlanetMasterPath}
      textColor="#a7000b"
      textSize={16}
      textPosition={-8}
      {...props}
    />
  )
}

const TelegramPath = config<string>('links.telegram')
export function Telegram(props: ButtonProps) {
  return (
    <Button
      size="large"
      color="inherit"
      startIcon={<SvgICon component={IconTelegram} fontSize={props.size ?? 'large'} inheritViewBox />}
      href={TelegramPath}
      {...props}
    />
  )
}

export function ComingSoon({ image, href, title, ...props }: Partial<ImageLinkProps>) {
  return (
    <ImageLink
      image={coming}
      href=""
      textColor="#ea5422bb"
      textSize={24}
      textPosition={-8}
      {...props}
    />
  )
}
